// NOTE: hooks
import { useState } from 'react'
import useLink from './useLink'
// NOTE: icons
import { FaVideoSlash as VideoSlash } from "react-icons/fa6"
// NOTE: components
import ReactPlayer from 'react-player'
import EmptyPrompt from '../ui/EmptyPrompt'
interface LinkVideoProps {
    link: string
}

const LinkVideo = ({ link }: LinkVideoProps) => {
    const { isLoadingLink, isErrorLink, errorLink, linkData } = useLink(link)
    
    const [videoError, setVideoError] = useState(false)

    const handleVideoError = () => {
        console.error("The link might be invalid")
        setVideoError(true)
    }

    if (isLoadingLink) return <div className="my-4 rounded-2xl h-[400px] skeleton" />

    if (isErrorLink) {
        console.error("We couldn't get your link", errorLink?.message)
    }

    return (
        <>
            {!isErrorLink && !videoError && (
                <div className="h-[400px] w-full my-4 rounded-lg overflow-hidden">
                    <ReactPlayer
                        width="100%"
                        height="100%"
                        url={linkData?.url}
                        onError={handleVideoError}
                        playing={false}
                        controls={true}
                        config={{
                            file: {
                                attributes: {
                                    controlsList: 'nodownload'
                                }
                            }
                        }}
                    />
                </div>
            )}
            {(isErrorLink || videoError) && (
                <EmptyPrompt
                    illustration={<VideoSlash className="h-auto w-full" />}
                    title="We couldn't display your video"
                    description="The link may be broken, or the video might no longer exist."
                />
            )}
        </>
    )
}

export default LinkVideo